module.exports = __webpack_public_path__ + "static/media/hands-quizz.3c21802d.jpg";